module.exports = __webpack_public_path__ + "mf.4f9c402109e508a66d09.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mf.svg
// module chunks = styles